(() => {
  if (window.hugcoffeeFrozenCart) return;

  const stateSelector = '[data-cart-frozen-state]';
  let revision = 0;
  let themeRequests = 0;

  document.addEventListener('theme:loading:start', () => { themeRequests += 1; });
  document.addEventListener('theme:loading:end', () => { themeRequests = Math.max(0, themeRequests - 1); });

  function waitForTheme() {
    if (themeRequests === 0) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        document.removeEventListener('theme:loading:end', onEnd);
        reject(new Error('カートの更新が完了していません。少し待ってからもう一度お試しください。'));
      }, 15000);
      const onEnd = () => {
        if (themeRequests !== 0) return;
        clearTimeout(timeout);
        document.removeEventListener('theme:loading:end', onEnd);
        resolve();
      };
      document.addEventListener('theme:loading:end', onEnd);
    });
  }

  function mixed(cart) {
    const id = Number(document.querySelector(stateSelector)?.dataset.frozenProductId);
    if (!Number.isSafeInteger(id) || id <= 0 || !Array.isArray(cart?.items)) {
      throw new Error('カート内容を確認できません。ページを再読み込みしてください。');
    }
    let frozen = false, other = false;
    for (const item of cart.items) {
      if (!Number.isSafeInteger(Number(item.product_id)) || Number(item.product_id) <= 0 ||
          !Number.isSafeInteger(Number(item.quantity)) || Number(item.quantity) < 0) {
        throw new Error('カート内容を確認できません。ページを再読み込みしてください。');
      }
      if (Number(item.quantity) === 0) continue;
      if (Number(item.product_id) === id || Number(item.product_id) === 9856322142425) frozen = true;
      else other = true;
    }
    return frozen && other;
  }

  function render(blocked, node) {
    node.hidden = !blocked;
    node.dataset.mixed = String(blocked);
    const form = node.closest('form[data-shipping-preference-cart]');
    if (!form) return;
    const wasMixed = form.dataset.frozenCartMixed === 'true';
    form.dataset.frozenCartMixed = String(blocked);
    form.querySelectorAll('[name="checkout"]').forEach(button => {
      if (blocked) {
        if (button.dataset.frozenWasDisabled === undefined) {
          button.dataset.frozenWasDisabled = String(button.disabled && !wasMixed &&
            form.dataset.shippingPreferencePending !== 'true');
        }
        button.disabled = true;
      } else if (button.dataset.frozenWasDisabled !== undefined &&
                 form.dataset.shippingPreferencePending !== 'true') {
        button.disabled = button.dataset.frozenWasDisabled === 'true';
        delete button.dataset.frozenWasDisabled;
      }
    });
    form.querySelectorAll('.additional-checkout-buttons').forEach(buttons => {
      if (blocked) {
        if (buttons.dataset.frozenWasHidden === undefined) {
          buttons.dataset.frozenWasHidden = String(buttons.hidden);
          buttons.dataset.frozenWasInert = String(buttons.inert);
        }
        buttons.hidden = true;
        buttons.inert = true;
      } else if (buttons.dataset.frozenWasHidden !== undefined) {
        buttons.hidden = buttons.dataset.frozenWasHidden === 'true';
        buttons.inert = buttons.dataset.frozenWasInert === 'true';
        delete buttons.dataset.frozenWasHidden;
        delete buttons.dataset.frozenWasInert;
      }
    });
  }

  function renderCart(cart) {
    const blocked = mixed(cart);
    document.querySelectorAll(stateSelector).forEach(node => render(blocked, node));
    return blocked;
  }

  function syncMarkup() {
    document.querySelectorAll(stateSelector).forEach(node => render(node.dataset.mixed === 'true', node));
  }

  async function readCart() {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error('カート内容を確認できません。少し待ってからもう一度お試しください。');
    return response.json();
  }

  async function refresh() {
    const current = ++revision;
    try {
      const cart = await readCart();
      if (current === revision) renderCart(cart);
    } catch (_) {
      // Keep the server-rendered state. Checkout performs a mandatory fresh check.
    }
  }

  document.addEventListener('cart:change', event => {
    revision += 1;
    if (event.detail?.cart?.items) {
      try { renderCart(event.detail.cart); } catch (_) { refresh(); }
    } else refresh();
  });
  ['cart:refresh', 'cart-drawer:refreshed', 'shopify:section:load'].forEach(name => {
    document.addEventListener(name, refresh);
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.matches?.(stateSelector) || node.querySelector?.(stateSelector)
    ))) {
      syncMarkup();
      refresh();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', event => {
    syncMarkup();
    if (event.persisted) refresh();
  });

  window.hugcoffeeFrozenCart = {
    async prepareCheckout() {
      try {
        revision += 1;
        await waitForTheme();
        if (renderCart(await readCart())) {
          const error = new Error('冷凍商品と通常商品は同時にご注文いただけません。\n恐れ入りますが、カートを分けてご購入いただけますようお願いいたします。');
          error.code = 'FROZEN_CART_MIXED';
          throw error;
        }
      } catch (error) {
        if (error.code !== 'FROZEN_CART_MIXED') error.code = 'FROZEN_CART_CHECK_FAILED';
        throw error;
      }
    },
    syncMarkup
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncMarkup, { once: true });
  else syncMarkup();
})();
